import { LucideProvider } from "lucide-react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { AuthProvider } from "./auth/AuthContext";
import { App } from "./App";
import { initSentry } from "./lib/sentry";

initSentry();

const elem = document.getElementById("root")!;

const app = (
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <LucideProvider strokeWidth={1.5}>
          <App />
        </LucideProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>
);

(import.meta.hot.data.root ??= createRoot(elem)).render(app);
